const defaultRender = (value) => (value || value === 0 ? value : "--");

const columns = [
  {
    title: "Services",
    dataIndex: "service_name",
    render: defaultRender,
    width : 200,
  },
  {
    title: "Unsubmitted",
    dataIndex: "unsubmitted_files",
    render: (value) => (
      <span className="px-2 py-1 text-xs rounded-full bg-red-50 text-red-600 font-medium">
        {defaultRender(value)}
      </span>
    ),
  },
  {
    title: "In-Process",
    dataIndex: "in_process_files",
    render: (value) => (
      <span className="px-2 py-1 text-xs rounded-full bg-yellow-50 text-yellow-600 font-medium">
        {defaultRender(value)}
      </span>
    ),
  },
  {
    title: "Closed",
    dataIndex: "closed_files",
    render: (value) => (
      <span className="px-2 py-1 text-xs rounded-full bg-green-50 text-green-600 font-medium">
        {defaultRender(value)}
      </span>
    ),
  },
  {
    title: "Total Files",
    dataIndex: "total_files",
    render: (value) => (
      <span className="font-semibold text-gray-900">
        {defaultRender(value)}
      </span>
    ),
  },
];

export default columns;
